import { chakra } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ChakraIcon = chakra(FontAwesomeIcon);
